import { useQuery } from "@tanstack/react-query";
import { REPORT_SERVICE, restApiRequest } from "src/utils/Api";
import mockBenefitsData from "src/Pages/Company/Products/Subscriptions/utils/mockBenefitsData";
import sortByField from "src/utils/jsHelpers/sortByField";
import { pick } from "lodash";

const useCompanySubscriptions = (
  companyId: string,
  enabled: boolean,
  asOptions: boolean
) =>
  useQuery({
    enabled,
    queryKey: ["report-trs-dict-subscriptions", { companyId }],
    queryFn: () =>
      restApiRequest(
        REPORT_SERVICE,
        `/Trs/Dictionary/Subscriptions/${companyId}`,
        "GET",
        {},
        mockBenefitsData.map((o) => pick(o, ["id", "name"]))
      ),
    select: (
      data: {
        id: string;
        name: string;
      }[]
    ) =>
      asOptions
        ? sortByField(
            data?.map(({ name, id }) => ({
              value: id,
              label: name,
            })) || [],
            "label"
          )
        : data,
  });

export default useCompanySubscriptions;
